function getBrowserLocale(): string | undefined {
  return typeof navigator !== 'undefined' ? navigator.language : undefined;
}

export function formatPrice(amount: number, currency: string): string {
  return new Intl.NumberFormat(getBrowserLocale(), {
    style: 'currency',
    currency,
  }).format(amount);
}

export function formatDate(
  date: Date | string,
  month: 'short' | 'long' = 'short',
): string {
  return new Intl.DateTimeFormat(getBrowserLocale(), {
    day: 'numeric',
    month,
    year: 'numeric',
  }).format(new Date(date));
}

export function formatDateTime(
  date: Date | string,
  month: 'short' | 'long' = 'short',
): string {
  return new Intl.DateTimeFormat(getBrowserLocale(), {
    day: 'numeric',
    month,
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
  }).format(new Date(date));
}
